export const forgotPassword = {
    "forgot_pwd_title": "Olvidé mi contraseña",
    "forgot_pwd_email": "Correo electrónico",
    "forgot_pwd_error": "Error al enviar el correo electrónico",
    "forgot_pwd_success": "Correo electrónico enviado",
    "forgot_pwd_submit": "Recuperar contraseña",
    "reset_pwd_title": "Restablecer tu contraseña",
    "reset_pwd_submit": "Restablecer contraseña",
}
